import { openBlock as l, createElementBlock as o, createElementVNode as e } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(c, t) {
  return l(), o("svg", r, [...t[0] || (t[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "M11.1 7.5h1.8v1.8h-1.8zm0 3.6h1.8v5.4h-1.8zM12 3c-4.968 0-9 4.032-9 9s4.032 9 9 9 9-4.032 9-9-4.032-9-9-9m0 16.2c-3.969 0-7.2-3.231-7.2-7.2S8.031 4.8 12 4.8s7.2 3.231 7.2 7.2-3.231 7.2-7.2 7.2"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
